import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilityService } from 'src/app/inventory/sales-order/utils/utility.service';

export interface HierarchicalPostingPeriod {
    id: number;
    name: string;
    children: HierarchicalPostingPeriod[];
    year: number;
    monthId: number;
    startDate: Date;
    endDate: Date;
}

@Injectable({
    providedIn: 'root'
})
export class PostingPeriodListService {
    private readonly financeURl: string = environment.financeURl;
    private postingPeriodsSubject = new BehaviorSubject<HierarchicalPostingPeriod[]>([]);
    public postingPeriods$ = this.postingPeriodsSubject.asObservable();

    constructor(private http: HttpClient,
        private utilityService: UtilityService
    ) { }

    async fetchPostingPeriods(): Promise<HierarchicalPostingPeriod[]> {
        const cachedData = this.postingPeriodsSubject.getValue();

        if (cachedData && cachedData.length > 0) {
            return cachedData;
        } else {
            try {
                const response = await this.http.get<HierarchicalPostingPeriod[]>(`${this.financeURl}ClosingYear/PostingPeriod`).toPromise();
                if (response) {
                    this.postingPeriodsSubject.next(response);
                    return response;
                }
                return [];
            } catch (err) {
                console.error('Error fetching posting periods:', err);
                return [];
            }
        }
    }

    clearPostingPeriods(): void {
        this.postingPeriodsSubject.next([]);
    }

    clearAndFetchPostingPeriods(): void {
        this.clearPostingPeriods();
        this.fetchPostingPeriods();
    }

    get currentPostingPeriods(): HierarchicalPostingPeriod[] {
        return this.postingPeriodsSubject.value;
    }

    get isAllowPostingPeriod(): boolean {
        const iSettings = this.utilityService.getISettings();
        return iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
    }
} 